/**
 * List Schema of CargaKarcher
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaKarcher} from '@/model/resource/CargaKarcher'

/* TODO: review generated schema */
export class ListCargaKarcherSchema extends Schema {
  readonly name = 'ListCargaKarcher'

  readonly fieldSet: FieldSet<CargaKarcher> = {
    idCargaInfoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    nomeArquivo: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataInicioDownload: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataInicioDownload),
      },
    }),
  }
}
